import React from 'react';
import Card from '../../../../Presentation/components/ui/Card';
import {StoreStatistics} from '../../models/store.model';

interface StoresStatisticsDetailsProps {
  statistics: StoreStatistics | null;
}

export const StoresStatisticsDetails: React.FC<StoresStatisticsDetailsProps> = ({
  statistics
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-bold text-gray-900 mb-4">تفاصيل إضافية</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="text-center p-4 bg-gray-50 rounded-lg">
          <p className="text-2xl font-bold text-gray-600">{statistics?.inactiveStores || 0}</p>
          <p className="text-sm text-gray-600">متاجر غير نشطة</p>
        </div>

        <div className="text-center p-4 bg-red-50 rounded-lg">
          <p className="text-2xl font-bold text-red-600">{statistics?.outOfStockStores || 0}</p>
          <p className="text-sm text-gray-600">متاجر بلا مخزون</p>
        </div>
      </div>
    </Card>
  );
};
